module.exports = __webpack_public_path__ + "static/media/client.c67c2b52.jpg";